<template>
  <div>
    <v-card
      flat
      :loading="loading"
      class="tab-details"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text class="black--text">
        <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
          {{ local.caseFile.tabHeaders.caseParties }}
        </div>
        <v-row>
          <v-col
            cols="5"
            class=" mx-12"
          >
            <parties-card
              v-if="!loading"
              :title="local.common.theProsecutorList"
              :parties="prosecutors"
            ></parties-card>
          </v-col>
          <v-col
            cols="5"
            class="mx-12"
          >
            <parties-card
              v-if="!loading"
              :title="local.common.theDefendantList"
              :parties="defendants"
            ></parties-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import PartiesCard from '../cards/parties-card.vue';
const { mapActions } = createNamespacedHelpers('CasesModule');
import { casePartyRoleEnum } from '@/helpers/enum';

export default {
  name: 'CasePartiesTab',
  components: { PartiesCard },
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      caseParties: [],
      loading: false,
    };
  },
  computed: {
    defendants() {
      return (this.caseParties || []).filter(cp => cp.casePartyRole == casePartyRoleEnum.defendant);
    },
    prosecutors() {
      return (this.caseParties || []).filter(cp => cp.casePartyRole == casePartyRoleEnum.prosecutor);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions([
      'getCasePartiesDetails',
    ]),
    loadData() {
      const params = {
        objectKey: this.caseObjectKey,
        isPega: this.isPega,
      };
      this.loading = true;
      this.getCasePartiesDetails(params)
        .then((res) => {
          this.caseParties = res.data;
        })
        .finally(() => (this.loading = false));
    },
  },
};

</script>

<style scoped>
</style>